"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCategoriesResponseToJSON = exports.AdCategoriesResponseFromJSONTyped = exports.AdCategoriesResponseFromJSON = exports.instanceOfAdCategoriesResponse = void 0;
var runtime_1 = require("../runtime");
var AdCategory_1 = require("./AdCategory");
/**
 * Check if a given object implements the AdCategoriesResponse interface.
 */
function instanceOfAdCategoriesResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdCategoriesResponse = instanceOfAdCategoriesResponse;
function AdCategoriesResponseFromJSON(json) {
    return AdCategoriesResponseFromJSONTyped(json, false);
}
exports.AdCategoriesResponseFromJSON = AdCategoriesResponseFromJSON;
function AdCategoriesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : (json['categories'].map(AdCategory_1.AdCategoryFromJSON)),
    };
}
exports.AdCategoriesResponseFromJSONTyped = AdCategoriesResponseFromJSONTyped;
function AdCategoriesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'categories': value.categories === undefined ? undefined : (value.categories.map(AdCategory_1.AdCategoryToJSON)),
    };
}
exports.AdCategoriesResponseToJSON = AdCategoriesResponseToJSON;
